export default "__VITE_ASSET__C$RSy2CW__"